import type { AnnouncementProblem } from '@opengov/analytics/react';

/**
 * `onError` for the announcement banner: a rejected announcement or an
 * unreachable status page, reported to Faro and tagged `announcements`.
 *
 * The SDK calls this once per problem — never per poll — and never shows a
 * broken announcement, so this is the only way its author finds out. Uses the
 * `window.faro` global, like `reportAnalyticsError` in `ogAnalytics.ts`.
 */
export function reportAnnouncementProblemToFaro(problem: AnnouncementProblem): void {
  const message =
    problem.kind === 'invalid-announcement'
      ? `Announcement "${problem.key}" was not shown: ${problem.reason}`
      : `opengovstatus.com unreachable after ${problem.failures} attempts: ${problem.lastError}`;
  try {
    window.faro?.api.pushError(new Error(message), {
      context: { feature: 'announcements', kind: problem.kind },
    });
  } catch {
    // Reporting must never break the page it reports on.
  }
}
